// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'; // 確保已載入此行
import '@fortawesome/fontawesome-free/css/all.css';

// Vuetify
import 'vuetify/styles'

const app = createApp(App);
app.use(router);
app.use(vuetify);
app.mount('#app');
